<template>
  <div class="content">
    <!-- <el-button class="baocun" @click="setUserInfo">保存</el-button> -->
    <div class="personal-data">
      <!-- 头像 -->
      <div class="photo">
        <div v-loading="isHeadLoading" class="photo-1">
          <el-upload
            action=""
            :disabled="isHeadLock"
            :http-request="uploadHead"
            :show-file-list="false"
          >
            <div class="photohead">
              <img v-if="hearPic" class="avatar" :src="hearPic" />
            </div>
            <span class="location"> <i class="el-icon-camera-solid"></i></span>
            <span class="characters">点击上传头像</span>
          </el-upload>
        </div>
      </div>
      <div class="information">
        <el-form ref="form" label-position="left" label-width="" :model="form">
          <el-form-item class="forms" label="姓名">
            <div class="idata nickname" @click="dialogChangeName = true">
              <div :name="form.name">{{ form.name || userInfo.nickname }}</div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-form-item>
          <el-form-item class="forms" label="性别">
            <div class="idata">
              <el-radio-group v-model="form.sex" @change="userChange">
                <el-radio label="0">女</el-radio>
                <el-radio label="1">男</el-radio>
                <el-radio label="2">保密</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item class="forms" label="年龄">
            <div class="idata">
              <el-date-picker
                v-model="form.old"
                :clearable="false"
                placeholder="请选择生日"
                type="date"
                value-format="yyyy-MM-dd"
                @change="userChange"
              />
            </div>
          </el-form-item>
          <el-form-item class="forms" label="职业">
            <div class="idata">
              <el-select
                v-model="form.job"
                placeholder="请选择"
                @change="userChange"
              >
                <el-option
                  v-for="job in jobList"
                  :key="job.id"
                  :label="job.name"
                  :value="job.id"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="forms" label="所在城市">
            <div class="idata">
              <el-cascader
                v-model="form.city"
                :options="options"
                placeholder="请选择"
                :props="{
                  label: 'name',
                  value: 'id',
                }"
                @change="userChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="phone">
      <div class="change" style="cursor: default">
        <span>绑定手机号</span>
        <div>
          <span>{{ userInfo.phone_hide }}</span>
        </div>
      </div>
      <div class="change" style="cursor: default">
        <span>微信绑定</span>
        <div v-if="!userInfo.wechat_info" class="wx">
          <span>未绑定</span>
          <icon-svg
            fill="#44b549"
            icon-class="weixin"
            style="margin-left: 10px; font-size: 22px"
          />
          <!-- <i class="el-icon-arrow-right"></i> -->
        </div>
        <div v-else class="wx">
          <span>{{ userInfo.wechat_info.nickname }}</span>
          <el-avatar
            size="small"
            :src="userInfo.wechat_info.headpic"
            style="margin-right: 0"
          />
          <!-- <i class="el-icon-arrow-right"></i> -->
        </div>
      </div>
      <div class="change" @click="dialogChangePass = true">
        <span>登录密码</span>
        <div><span>设置</span><i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <!-- 更改名字弹框 -->
    <el-dialog title="更改姓名" :visible.sync="dialogChangeName" width="500px">
      <el-input v-model="nameInput" placeholder="请输入您要更改的名字" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeName = false">取 消</el-button>
        <el-button type="primary" @click="confirmChangeName">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更换手机号弹框 -->
    <el-dialog
      class="changePhone"
      title="更换绑定手机号"
      :visible.sync="dialogChangePhone"
      width="500px"
    >
      <el-input v-model="phoneInput" placeholder="请输入您要更改的手机号" />
      <div class="yzm">
        <el-input v-model="yzmInput" placeholder="请输入验证码" />
        <div class="getPhoneYZM" @click="getTZM">获取验证码</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangePhone = false">取 消</el-button>
        <el-button type="primary" @click="changePhone">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 更换微信弹框 -->
    <el-dialog
      title="更换/解绑微信号"
      :visible.sync="dialogChangeWX"
      width="500px"
    >
      <el-input v-model="wxInput" placeholder="请输入您要更改的微信号" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeWX = false">取 消</el-button>
        <el-button type="primary" @click="changeWX">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设置密码弹框 -->
    <el-dialog
      title="设置登录密码"
      :visible.sync="dialogChangePass"
      width="500px"
    >
      <el-input
        v-model="passInput"
        clearable
        placeholder="请输入您要设置的密码"
        show-password
        type="password"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePass(false)">取 消</el-button>
        <el-button type="primary" @click="changePass">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserInfo,
  getCityList,
  getJobList,
  setUserInfo,
  postUserHead,
  changePhone,
  changeWechat,
  changePassword,
  getPhoneYzm,
} from '@/network/request'
import IconSvg from '../Icon-svg.vue'
export default {
  name: 'Zhanghushezhi',
  components: { IconSvg },
  data() {
    return {
      form: {
        name: '', // 名称
        sex: '', // 性别
        old: '', // 年龄
        job: '', // 职业
        city: [], // 城市
      },
      dialogChangeName: false, // 控制更改名字弹出框显示隐藏
      dialogChangePhone: false, // 控制更换手机号弹框的显示隐藏
      dialogChangeWX: false, // 控制更换微信号弹框的显示隐藏
      dialogChangePass: false, // 更换密码弹窗
      options: [], // 城市列表
      jobList: [], // 职业列表
      userInfo: {}, // 用户信息
      nameInput: '', // 更改名字的输入框
      phoneInput: '', // 更改手机号的输入框
      yzmInput: '', // 输入验证码的输入框
      wxInput: '',
      hearPic: '', // 用户头像
      passInput: '',
      isHeadLoading: false,
      isHeadLock: false,
    }
  },
  computed: {},
  created() {
    this.getUserInfo()
    this.getCityList()
    this.getJobList()
  },
  methods: {
    userChange() {
      this.setUserInfo()
    },
    // 读取用户信息
    async getUserInfo() {
      const res = await getUserInfo()
      // 用户信息
      this.userInfo = res.data.result
      // console.log(res.data.result)
      // 姓名
      this.form.name = res.data.result.nickname
      // 性别
      this.form.sex = String(res.data.result.sex) // 转字符串格式
      // 城市
      this.form.city = [
        res.data.result.province,
        res.data.result.city,
        res.data.result.region,
      ]
      // 头像
      this.hearPic = this.userInfo.headpic
      // 年龄
      this.form.old = res.data.result.birthday
      // 职业
      this.form.job = res.data.result.profession
    },
    // 获取城市信息
    async getCityList() {
      // 如果本地存储中有城市信息，则不走接口
      if (localStorage.getItem('city-list')) {
        this.options = JSON.parse(localStorage.getItem('city-list'))
      } else {
        const res = await getCityList()
        // console.log(res.data.result)
        this.options = res.data.result
        localStorage.setItem('city-list', JSON.stringify(res.data.result))
      }
    },
    // 获取职业列表
    async getJobList() {
      // 如果本地存储中有职业列表，则不走接口
      if (localStorage.getItem('job-list')) {
        this.jobList = JSON.parse(localStorage.getItem('job-list'))
      } else {
        const res = await getJobList()
        // console.log(res.data.result)
        this.jobList = res.data.result
        localStorage.setItem('job-list', JSON.stringify(res.data.result))
      }
    },
    // 更新用户信息
    async setUserInfo(callback = false) {
      const data = {
        nickname: this.form.name,
        sex: Number(this.form.sex),
        birthday: this.form.old,
        profession: this.form.job,
        province: this.form.city[0] || 0,
        city: this.form.city[1] || 0,
        region: this.form.city[2] || 0,
      }
      const res = await setUserInfo(data)
      if (res && callback) callback(res)
    },
    // 确认更改名字
    confirmChangeName() {
      // 更新用户信息
      this.form.name = this.nameInput
      this.setUserInfo((res) => {
        this.$store.dispatch('setUser', { nickname: res.data.result.nickname })
        this.dialogChangeName = false
      })
    },
    // 上传头像
    async uploadHead(e) {
      this.isHeadLoading = true
      this.isHeadLock = true
      const res = await postUserHead(e.file).catch(() => {
        this.isHeadLoading = false
        this.isHeadLock = false
      })
      this.hearPic = res.data.result
      this.$store.dispatch('setUser', { headpic: this.hearPic })
      this.isHeadLoading = false
      this.isHeadLock = false
    },
    // 更换手机号
    async changePhone() {
      const data = { phone: this.phoneInput, code: this.yzmInput }
      const res = await changePhone(data)
      this.dialogChangePhone = false
      this.userInfo.phone_hide = res.data.result
    },
    // 获取手机验证码
    async getTZM() {
      console.log(this.phoneInput)
      const res = await getPhoneYzm(this.phoneInput)
      console.log(res)
    },
    // 更换微信号
    async changeWX() {
      // 如果为空，则是取消绑定
      if (this.wxInput === '') {
        const res = await changeWechat()
        console.log(res)
        this.dialogChangeWX = false
        // 否则绑定微信
      } else {
        const res = await changeWechat(localStorage.getItem('user-token'))
        console.log(res)
        this.dialogChangeWX = false
      }
    },
    async changePass(e) {
      // 如果为空，则是取消绑定
      if (e && this.passInput !== '') {
        await changePassword(this.passInput)
      }
      this.dialogChangePass = false
      this.passInput = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
}
i {
  margin-left: 5px;
}
.nickname {
  cursor: pointer;
}
.yzm {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  .el-input {
    width: 60%;
  }
  .getPhoneYZM {
    display: flex;
    margin-right: 40px;
    margin-top: 10px;
    color: #5bc7f6;
    cursor: pointer;
  }
}

.personal-data {
  display: flex;
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  .photo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 353px;
    .photo-1 {
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .photohead {
        box-sizing: border-box;
        width: 120px;
        height: 120px;
        background-color: rgb(158, 158, 158);
        border-radius: 50%;
        margin-bottom: 10px;
        border: 2px solid #fff;
        overflow: hidden;
      }
      .location {
        position: absolute;
        right: 0px;
        bottom: 35px;
        display: flex;
        align-items: center;
        width: 30px;
        height: 30px;
        background-color: #5bc7f6;
        border-radius: 50%;
        i {
          font-size: 20px;
          color: #fff;
        }
      }
      .characters {
        font-size: 14px;
        color: #999999;
      }
    }
  }
  .information {
    position: relative;
    width: 50%;
  }
}
.el-form {
  position: absolute;
  top: -10px;
  width: 100%;

  ::v-deep(.el-form-item__label) {
    width: 80px;
    font-size: 16px;
  }
  .forms {
    display: flex;
    align-items: center;
    width: 350px;
    padding-bottom: 15px;
    padding-top: 15px;
    margin: 0;
    border-bottom: 1px solid #eeeeee;
  }
  .forms:last-child {
    border: 0;
  }
  .idata {
    width: 200px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: 65px;
  }
  .el-input {
    width: 100%;
  }
  ::v-deep(.el-input__inner) {
    width: 200px;
  }
}
.phone {
  padding: 0px 25px 0;
  border-radius: 12px;
  border: solid 1px #efefef;
  .change {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 25px;
    border-bottom: 1px solid #eeeeee;
    cursor: pointer;
    & > span {
      font-size: 16px;
      color: #333333;
    }
    & > div > span {
      font-size: 16px;
      color: #828282;
    }
  }
  .change:last-child {
    border: 0;
  }
  .wx {
    display: flex;
    align-items: center;
    span:nth-child(2) {
      width: 25px;
      height: 25px;
      background-color: wheat;
      border-radius: 50%;
      margin: 0 5px;
    }
  }
}
</style>
